// extracted by mini-css-extract-plugin
export default {"headerR":"NoPage_headerR__w4Fxm"};